export const ANSWERED = 'Answered';
export const NO_ANSWER = 'No-Answer';
export const LEFT_VOICE_MAIL = 'Left Voicemail';
export const IN_BOUND = 'In-Bound';


export const DONE = 1;
export const NOT_DONE = 3;
export const CURRENT = 2;
